export default "<div class=\"leva-width-common-main\" (click)=\"onCellClick()\">{{params?.value === null ? '-' : params?.value}}</div>\n"